import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TourStopsService } from './logic/tour-stop.service';
import { TourStopsLogicService } from './logic/tour-stop/tour-stop-logic.service';
import { TourStopsDaoService } from './dao/tour-stop-dao.service';
import { TourStopsDbDaoService } from './dao/tour-stop-dao/tour-stop-db-dao.service';
import { TourStopDbTableDefinition } from './dao/tour-stop-dao/tour-stop-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: TourStopsService, useClass: TourStopsLogicService },
    { provide: TourStopsDaoService, useClass: TourStopsDbDaoService },
    { provide: TourStopDbTableDefinition },
  ]
})
export class TourStopsModule {}
